import { MdastNodeType } from './types';

export const remarkTextTypes: MdastNodeType[] = [
  'emphasis',
  'strong',
  'delete',
  'inlineCode',
  'html',
  'text',
];
